<template>
  <div>
    <a v-if="this.person.whatsapp" :href="'https://wa.me/' +
      this.person.mobile_phone +
      '/?text=I\'m%20inquiring%20about%20the%20upclub%20app'
      " target="_blank" :class="!person.open_bussiness && 'disabled-anchor'"
      @click="sendClickToGA('upclub_offer', 'phone', analyticLabel)">
      <img class="contact-button" src="@/assets/images/whatsapp.svg" />
    </a>
    <a :class="!person.open_bussiness && 'disabled-anchor'" v-if="this.person.phone_flag" @click="sendClickToGA('upclub_offer', 'phone', analyticLabel)">
      <img v-b-tooltip.hover :title="[[this.person.mobile_phone]]" class="contact-button"
        src="@/assets/images/phone.svg" />
    </a>
    <a :class="!person.open_bussiness && 'disabled-anchor'" :href="'mailto:' + this.person.email"
      v-if="this.person.email_flag" @click="sendClickToGA('upclub_offer', 'phone', analyticLabel)">
      <img v-b-tooltip.hover :title="[[this.person.email]]" class="contact-button" src="@/assets/images/mail.svg" />
    </a>
  </div>
</template>

<script>

import { VBTooltip } from "bootstrap-vue";
import PersonContact from "./PersonContact.vue";

export default {
  name: "PersonContact",
  props: {
    user: Object,
    person: Object,
    offerName: String,
    offerId: Number
  },
  directive: {
    "v-b-tooltip": VBTooltip
  },
  data() {
    return {
      // offer: null,
    };
  },
  methods: {
    addFriend() {
      this.$emit("addFriend", this.person.id);
    },
  },
  computed: {
    analyticLabel: function () {
      console.log( this.offerId ?
        "Oferta: " + this.offerName + " (" + this.offerId + ") accesata de " + 
        this.user.person.first_name + " " + this.user.person.last_name + " (" + this.user.person.id + ") "
       : "Persoana: " +  this.person.first_name + " " + this.person.last_name + " (" + this.person.id + ") accesata de " + 
       this.user.person.first_name + " " + this.user.person.last_name + " (" + this.user.person.id + ") "
       );
      return (
        this.offerId  ?
        "Oferta: " + this.offerName + " (" + this.offerId + ") accesata de " + 
        this.user.person.first_name + " " + this.user.person.last_name + " (" + this.user.person.id + ") "
       : "Persoana: " +  this.person.first_name + " " + this.person.last_name + " (" + this.person.id + ") accesata de " + 
       this.user.person.first_name + " " + this.user.person.last_name + " (" + this.user.person.id + ") "
      ); 
    }
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
